import { createReducer } from 'deox'
import {
  addActiveListPools,
  addCompletedListPools,
  addUpcomingListPools,
  setStatusLoading,
  setOldPoolsAddress,
  setSerialisedPools,
  addMostTractionListPools,
  addRecentlyLaunchedListPools,
  addClosingSoonListPools,
  addMostFundedListPools,
  addAllListPools,
  setAllPoolsStatusLoading,
} from './actions'

import { IPoolListGroupedProps, IPoolListProps } from '../../types/reducerTypes'

const initialPoolsState: IPoolListProps = {
  active: [],
  upcoming: [],
  completed: [],
  mostTraction: [],
  recentlyLaunched: [],
  closingSoon: [],
  mostFunded: [],
  loading: false,
  oldPoolsAddress: [],
  serialisedPools: {},
}
export const initialState: IPoolListGroupedProps = {
  all: {
    pools: [],
    loading: false,
    total: 0,
  },
  labs: { ...initialPoolsState },
  launch: { ...initialPoolsState },
}

const accessReducer = createReducer(initialState, (handleAction) => {
  return [
    handleAction(setAllPoolsStatusLoading, (state, { payload }) => ({
      ...state,
      all: {
        ...state.all,
        loading: payload.loading,
      },
    })),
    handleAction(addAllListPools, (state, { payload }) => ({
      ...state,
      all: {
        ...state.all,
        total: payload.total,
        pools: [...payload.pools],
      },
    })),
    handleAction(addUpcomingListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        upcoming: Array.from(
          new Set([
            ...state[payload.type].upcoming.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(addActiveListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        active: Array.from(
          new Set([
            ...state[payload.type].active.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(addCompletedListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        completed: Array.from(
          new Set([
            ...state[payload.type].completed.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(addMostTractionListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        mostTraction: Array.from(
          new Set([
            ...state[payload.type].mostTraction.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(addRecentlyLaunchedListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        recentlyLaunched: Array.from(
          new Set([
            ...state[payload.type].recentlyLaunched.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(addClosingSoonListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        closingSoon: Array.from(
          new Set([
            ...state[payload.type].closingSoon.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(addMostFundedListPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        mostFunded: Array.from(
          new Set([
            ...state[payload.type].mostFunded.map(
              (oldsp) =>
                payload.pools.find(
                  (newsp) => newsp.address === oldsp.address,
                ) || oldsp,
            ),
            ...payload.pools,
          ]),
        ),
      },
    })),
    handleAction(setStatusLoading, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        loading: payload.loading,
      },
    })),
    handleAction(setOldPoolsAddress, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        oldPoolsAddress: payload.oldPoolsAddress,
      },
    })),
    handleAction(setSerialisedPools, (state, { payload }) => ({
      ...state,
      [payload.type]: {
        ...state[payload.type],
        serialisedPools: payload.serialisedPools,
      },
    })),
  ]
})

export default accessReducer
